import { connect } from "react-redux";
import { getFlattenedQuestionsFromMock } from "../../selectors/questionSelectors";
import QuestionPagination from "./QuestionPagination";

function mapStateToProps(state) {
  return {
    flattenedQuestions: getFlattenedQuestionsFromMock(state),
  };
}

export default connect(mapStateToProps)(QuestionPagination);
